import { useEffect, useState } from "react";
import { api, fmtDate, today, daysAgo } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";

export default function AuditLog() {
    const [from, setFrom] = useState(daysAgo(60));
    const [to, setTo] = useState(today());
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/reports/audit-log", { params: { date_from: from, date_to: to } }).then(({ data }) => setItems(data)); }, [from, to]);
    return (
        <>
            <PageHeader kicker="REPORTS • AUDIT" title="Audit Log" subtitle="Immutable record of every change."
                actions={<><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-[140px]" /><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-[140px]" /></>} />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    <table className="fin-table">
                        <thead><tr><th>Timestamp</th><th>User</th><th>Action</th><th>Entity</th><th>Details</th></tr></thead>
                        <tbody>{items.map((r) => (
                            <tr key={r.id}>
                                <td className="text-[12px] text-muted-foreground">{fmtDate(r.timestamp)}</td>
                                <td>{r.user_name}</td>
                                <td className="capitalize">{r.action.replace("_", " ")}</td>
                                <td className="capitalize text-[12px]">{r.entity}</td>
                                <td className="text-[11.5px] text-muted-foreground font-mono truncate max-w-[300px]">{JSON.stringify(r.details || {})}</td>
                            </tr>
                        ))}</tbody>
                    </table>
                </div>
            </PageBody>
        </>
    );
}
